"use client";

import { useSearchParams } from "next/navigation";
import Link from "next/link";
import { BRAND_COLORS } from "@/constants/colors";

export default function ErrorPage() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");

  const getErrorMessage = (error: string | null) => {
    switch (error) {
      case "OAuthSignin":
        return "User with this email does not exist. Please register first.";
      case "OAuthCallback":
        return "Failed to authenticate with Google. Please try again.";
      case "OAuthCreateAccount":
        return "Could not create account with Google.";
      case "OAuthAccountNotLinked":
        return "This email is already registered with a different method.";
      case "AccessDenied":
        return "Access denied. Please check your permissions.";
      default:
        return "An error occurred during sign in. Please try again.";
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: BRAND_COLORS.background.primary }}>
      <div className="max-w-md w-full px-6">
        <div className="text-center">
          <div className="text-6xl mb-4">👵</div>
          <h1 className="text-2xl font-bold mb-4" style={{ color: BRAND_COLORS.text.primary }}>
            Sign-In Error
          </h1>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-red-700">
              {getErrorMessage(error)}
            </p>
          </div>
          <div className="space-y-3">
            <Link
              href="/login"
              className="block w-full py-3 px-4 rounded-lg text-center font-semibold transition-colors"
              style={{
                backgroundColor: "#ec4899",
                color: "white",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "0.9";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "1";
              }}
            >
              Try Again
            </Link>
            <Link
              href="/register"
              className="block w-full py-3 px-4 rounded-lg text-center font-semibold border-2 transition-colors"
              style={{
                borderColor: BRAND_COLORS.border.default,
                color: BRAND_COLORS.text.primary,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f5f2f4";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              Create New Account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
